import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: '1px solid #e0e0e0',
    borderRadius: 8
  },
  adminRoot: { opacity: '50%' },
  top: { padding: `${theme.spacing(2)}px ${theme.spacing(2)}px` },
  bottom: { padding: `${theme.spacing(2)}px ${theme.spacing(2)}px` },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  }
}))
